export const constant = {
  path: "https://{subdomain}.ehiia.online/impacteq-gateway",
//  path:'https://b1fd-103-95-82-219.ngrok-free.app/impacteq-gateway'
  // path: "https://{subdomain}.impacteq.co.uk/impacteq-gateway",
  // superAdminPath: "http://3.10.190.114/admin-portal-api",

  // clientAdminPath: "http://3.10.190.114/client-portal-api",
};
